module.exports = __webpack_public_path__ + "img/SketchPngea429440991db2526652044f0bfb84259725e43aaa99a135d48fb67f9999ec9a.c9f0351f.png";